if (!customElements.get('hp-tabbed-panel')) {
  class HpTabbedPanel extends HTMLElement {
    connectedCallback() {
      this._tabs   = Array.from(this.querySelectorAll('[data-hpct-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-hpct-panel]'));
      this._scroll = this.querySelector('[data-hpct-scroll]');
      this._bar    = this.querySelector('[data-hpct-bar]');
      this._prompt = this.querySelector('[data-hpct-prompt]');
      this._arrowL = this.querySelector('[data-hpct-arrow="left"]');
      this._arrowR = this.querySelector('[data-hpct-arrow="right"]');

      if (!this._tabs.length) return;

      this._tabs.forEach(tab => {
        tab.addEventListener('click', () => this._activate(tab.dataset.hpctTab));
      });

      if (this._arrowL) this._arrowL.addEventListener('click', () => {
        this._scroll.scrollLeft -= 120;
      });
      if (this._arrowR) this._arrowR.addEventListener('click', () => {
        this._scroll.scrollLeft += 120;
      });

      if (this._scroll) {
        this._scroll.addEventListener('scroll', () => this._updateArrows(), { passive: true });
        this._updateArrows();
      }

      const firstActive = this._tabs.find(t => t.classList.contains('is-active'));
      if (firstActive) this._setBar(firstActive);
    }

    _activate(id) {
      if (this._prompt) this._prompt.hidden = true;

      this._tabs.forEach(tab => {
        const active = tab.dataset.hpctTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) this._setBar(tab);
      });

      this._panels.forEach(panel => {
        panel.classList.toggle('is-active', panel.dataset.hpctPanel === id);
      });
    }

    _setBar(tab) {
      if (!this._bar) return;
      const accent = getComputedStyle(tab).getPropertyValue('--hpct-accent').trim()
        || tab.style.getPropertyValue('--hpct-accent');
      if (accent) this._bar.style.background = accent;
    }

    _updateArrows() {
      if (!this._scroll || !this._arrowL || !this._arrowR) return;
      if (window.innerWidth >= 640) {
        this._arrowL.hidden = true;
        this._arrowR.hidden = true;
        return;
      }
      const { scrollLeft, scrollWidth, clientWidth } = this._scroll;
      this._arrowL.hidden = scrollLeft <= 4;
      this._arrowR.hidden = scrollLeft >= scrollWidth - clientWidth - 4;
    }
  }

  customElements.define('hp-tabbed-panel', HpTabbedPanel);
}
